<template>
  <div class="card-header">
    <div class="card-header__content">
      <slot />
    </div>
    <AppBackground triangles="first" />
  </div>
</template>

<script>
export default {
  name: "AppCardHeader"
};
</script>

<style lang="scss" scoped>
$color: colors(palette-3);

.card-header {
  height: 40px;
  width: 100%;
  padding: 5px 20px;
  position: relative;
  color: colors(text-1);
  z-index: 2;

  &__content {
    height: 100%;
  }
}
</style>
